"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var stripe_js_1 = require("@stripe/stripe-js");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var constants_1 = require("common/constants");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var utils_1 = require("utils/selectors/utils");
var Header_1 = __importDefault(require("../StripeClientAgreement/Header")); // ToDo: make a common folder in containersRechargly/PublicCustomer
var CheckoutForm_1 = __importDefault(require("./CheckoutForm"));
var Wrapper_1 = __importDefault(require("./Wrapper"));
var selectPublicCustomers = (0, utils_1.makeSelectOrdered)('recharged_customers_public');
var StripeSetPaymentMethod = function () {
    var _a = (0, hooks_1.useQParams)(), customerId = _a.cId, setupIntentId = _a.confirmSetupIntent, accAt = _a.accAt, crwld = _a.crwld;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'recharged_customers_public', doc: customerId }]; });
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, backend_1.useCall)('stripe-createsessionforsetup', {
        customerId: customerId,
        userAgent: navigator.userAgent, forStripeElements: true,
    }), 2), callCreateSession = _b[0], isLoading = _b[1];
    var _c = __read((0, backend_1.useCall)('stripe-confirmsetupintent', { customerId: customerId }), 2), callConfirmSetupIntent = _c[0], isConfirmingSetupIntent = _c[1];
    var _d = __read((0, react_1.useState)(), 2), rechargerStripe = _d[0], setRechargerStripe = _d[1];
    var _e = __read((0, react_1.useState)(), 2), createSessionData = _e[0], setCreateSessionData = _e[1];
    var theme = (0, material_1.useTheme)();
    var publicCustomers = (0, react_redux_1.useSelector)(selectPublicCustomers);
    var publicCustomer = publicCustomers === null || publicCustomers === void 0 ? void 0 : publicCustomers[0];
    (0, react_1.useEffect)(function () {
        if (!setupIntentId)
            return;
        (0, hooks_1.setQParam)('confirmSetupIntent', history)('');
        callConfirmSetupIntent({ setupIntentId: setupIntentId, isCrawled: !!crwld })().then(function () {
            // ToDo: send user directly to /client-agreement
            history.push("/client-agreement?".concat(new URLSearchParams({ cId: customerId })));
        });
    }, [setupIntentId]);
    (0, react_1.useEffect)(function () {
        if (!customerId || setupIntentId)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var createSessionDataFromReq;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, callCreateSession({ acceptedAt: accAt ? +accAt : undefined })()
                            .then(function (res) { return res === null || res === void 0 ? void 0 : res.data; })];
                    case 1:
                        createSessionDataFromReq = _a.sent();
                        setRechargerStripe((0, stripe_js_1.loadStripe)(createSessionDataFromReq.publishableKey, {
                            betas: createSessionDataFromReq.isNzBecs ? ['nz_bank_account_beta_2'] : [],
                            apiVersion: createSessionDataFromReq.isNzBecs ? '2024-04-10;nz_bank_account_beta=v2' : undefined,
                            stripeAccount: createSessionDataFromReq.stripeAccountId,
                        }));
                        setCreateSessionData(createSessionDataFromReq);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [customerId]);
    if (setupIntentId || isLoading || isConfirmingSetupIntent) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, { brand: publicCustomer === null || publicCustomer === void 0 ? void 0 : publicCustomer.rechargerCompany }), (0, jsx_runtime_1.jsx)(Wrapper_1.default, { children: rechargerStripe && createSessionData && ((0, jsx_runtime_1.jsx)(react_stripe_js_1.Elements, __assign({ stripe: rechargerStripe, options: {
                        clientSecret: createSessionData === null || createSessionData === void 0 ? void 0 : createSessionData.setupClientSecret,
                        appearance: {
                            rules: {
                                '.Input': {
                                    borderColor: theme.palette.grey[300],
                                    marginTop: theme.spacing(1),
                                    marginBotton: theme.spacing(0.25),
                                    padding: theme.spacing(1.25, 2),
                                    boxShadow: 'none',
                                },
                                '.Input--empty': { borderColor: theme.palette.primary.light },
                                '.Input:focus': { borderColor: theme.palette.primary.contrastText },
                            },
                            variables: {
                                colorText: constants_1.COLORS.riverstone,
                                colorPrimary: theme.palette.primary.main,
                                borderRadius: theme.spacing(0.75),
                                focusBoxShadow: 'none',
                            },
                        },
                    } }, { children: (0, jsx_runtime_1.jsx)(CheckoutForm_1.default, { setupIntentId: createSessionData.setupIntentId, customerId: customerId }) }))) })] }));
};
exports.default = StripeSetPaymentMethod;
